import { useEffect } from 'react';

const useAutoFocus = ref => {
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);
};

export default useAutoFocus;
